import http from '@/utils/http';

const TOKEN_API_PREFIX = '/api/v1/permission/personal-token';

/** 令牌类型枚举 */
export type TPersonalTokenType = 'personal_token' | 'game_wiki';

/** 各类型默认有效期（月） */
export const PERSONAL_TOKEN_DEFAULT_EXPIRE_MONTHS: Record<TPersonalTokenType, number> = {
  personal_token: 3,
  game_wiki: 12,
};

export interface ICreatePersonalTokenReq {
  token_name: string;
  token_type: TPersonalTokenType;
  /** 有效期类型（月）：personal_token 为 3，game_wiki 为 12 */
  expire_type: number;
}

export interface IFetchPersonalTokensResp {
  list: Array<{
    id: number;
    token_name: string;
    token_type: TPersonalTokenType;
    masked_token: string;
    expire_time: string;
    created_time: string;
  }>;
  total: number;
}

export interface ICreatePersonalTokenResp {
  id: number;
  token_name: string;
  token?: string;
  token_type?: TPersonalTokenType;
  expire_time: string;
}

export interface IPersonalTokenDetailResp {
  id: number;
  token_name: string;
  token: string;
  token_type?: TPersonalTokenType;
  expire_time: string;
}

export interface IRenewPersonalTokenResp {
  id: number;
  token_name: string;
  expire_time: string;
}

export const fetchPersonalTokens = (): IBaseResponse<IFetchPersonalTokensResp> => {
  return http({
    url: `${TOKEN_API_PREFIX}/list`,
    method: 'get',
    rawData: true,
    errorHandler: true,
  }) as any;
};

export const createPersonalToken = (
  params: ICreatePersonalTokenReq,
): IBaseResponse<ICreatePersonalTokenResp> => {
  return http({
    url: TOKEN_API_PREFIX,
    method: 'post',
    data: params,
    rawData: true,
    errorHandler: true,
  }) as any;
};

export const fetchPersonalTokenDetail = (id: number): IBaseResponse<IPersonalTokenDetailResp> => {
  return http({
    url: `${TOKEN_API_PREFIX}/${id}`,
    method: 'get',
    rawData: true,
    errorHandler: true,
  }) as any;
};

export const renewPersonalToken = (id: number): IBaseResponse<IRenewPersonalTokenResp> => {
  return http({
    url: `${TOKEN_API_PREFIX}/${id}/renew`,
    method: 'put',
    rawData: true,
    errorHandler: true,
  }) as any;
};

export const revokePersonalToken = (id: number): IBaseResponse => {
  return http({
    url: `${TOKEN_API_PREFIX}/${id}`,
    method: 'delete',
    rawData: true,
    errorHandler: true,
  }) as any;
};